export default __webpack_public_path__ + "static/media/Apple_Pay_Mark_RGB_041619.04030e66.svg";